import {SK_CMS_DATA} from './data';
import {cr} from 'fire-wind-water';

export function splitContainer(data) {
  SK_CMS_DATA.ys.template = data;
  SK_CMS_DATA.container = {};
  cr.each(SK_CMS_DATA.mainContainer, (d) => {
    const dom = document.getElementById(d.name);
    if (dom) {
      dom.innerHTML = '';
    }
  });
  if (data.items) {
    cr.each(data.items, (d) => {
      if (!SK_CMS_DATA.container[d.container]) {
        SK_CMS_DATA.container[d.container] = [];
      }
      const style = {};
      cr.each(d.historyContent.style, (h) => {
        style[h.key] = h.value;
      });
      d.historyContent.style = style;
      SK_CMS_DATA.container[d.container].push(d);
      SK_CMS_DATA.components[d.id] = d;
    });
  }
}

export function updateContainer(res) {
  const data = {
    category: res.category,
    content: res.content,
    historyContent: res.content,
    orderId: res.index,
    historyOrderId: res.index,
    id: res.content.id,
    name: res.content.name,
    type: res.content.type,
    container: res.content.container
  };
  const style = {};
  cr.each(data.content.style, (h) => {
    style[h.key] = h.value;
  });
  data.content.style = style;
  if (!SK_CMS_DATA.container[data.container]) {
    SK_CMS_DATA.container[data.container] = [];
  }
  const o = SK_CMS_DATA.container[data.container];
  let isAdd = true;
  for (let i = 0; i < o.length; i++) {
    if (o[i].id == data.id) {
      o[i] = data;
      isAdd = false;
      break;
    }
  }
  if (isAdd) {
    o.push(data);
    if (SK_CMS_DATA.ys.template && SK_CMS_DATA.ys.template.items) {
      SK_CMS_DATA.ys.template.items.push(data);
    }
  } else {
    cr.each(SK_CMS_DATA.ys.template.items, (d, i) => {
      if(d.id == data.id){
        SK_CMS_DATA.ys.template.items[i] = data;
      }
    });
  }
  SK_CMS_DATA.components[data.id] = data;
}